/* Vague 96.14 — Centralised HTML sanitizer used by every component that
   renders user-controlled HTML via dangerouslySetInnerHTML.

   We allow inline styles (signatures rely on them) but DOMPurify still
   strips event handlers, javascript: URIs, and any tag in the deny list. */
import DOMPurify from 'dompurify';

const RICH_CONFIG = {
  ALLOWED_TAGS: [
    'a', 'b', 'blockquote', 'br', 'div', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'hr', 'i', 'img', 'li', 'ol', 'p', 'pre', 'span', 's', 'strong', 'sub', 'sup',
    'table', 'tbody', 'td', 'th', 'thead', 'tr', 'u', 'ul', 'code',
  ],
  ALLOWED_ATTR: [
    'href', 'target', 'rel', 'src', 'alt', 'title', 'style', 'class', 'width', 'height',
  ],
  // Critical: block javascript:/vbscript:/data:html (but allow data:image for inline signatures)
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel|cid|data:image\/(?:png|jpe?g|gif|webp|svg\+xml));?|[#/.?])/i,
  ALLOW_DATA_ATTR: false,
};

/* Returns a sanitized HTML string safe to inject via dangerouslySetInnerHTML. */
export function sanitizeRichHtml(html) {
  if (!html || typeof html !== 'string') return '';
  return DOMPurify.sanitize(html, RICH_CONFIG);
}

/* Strip ALL HTML tags — useful for plain-text fallbacks. */
export function stripHtml(html) {
  if (!html) return '';
  return DOMPurify.sanitize(html, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }).trim();
}
